import Vue from 'vue'
import Router from 'vue-router'

// Containers
import * as Container from '@/containers'

// Views
import * as Views from '@/views'

Vue.use(Router)

export default new Router({
  mode: 'hash', // hash or
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    { path: '/', redirect: '/dashboard', name: 'main', meta: { label: 'Main', requiresAuth: true }, component: Container.Private,
      children: [
        { path: 'dashboard', name: 'Dashboard_main', meta: { label: 'Dashboard' }, component: Views.Dashboard_main },
        { path: 'management/profile/:tag?', name: 'profile', meta: { label: 'Profile' }, component: Views.Profile.Base },
        { path: 'management/user/:id?/:tag?', name: 'user', meta:{ label: 'User'}, component: Views.User.Base },
        { path: 'management/group/:id?/:tab?', name: 'group', meta:{ label: 'Group'}, component: Views.Group.Base },
        // { path: 'management/billing/:tag?', name: 'billing', meta: { label: 'Billing' }, component: Views.Billing.Base },
        { path: 'management/invoice_group/:id?/:tag?', name: 'invoice_group', meta: { label: 'InvoiceGroup' }, component: Views.Invoice.Base },
        { path: 'management/invoice_partner/:id?/:tag?', name: 'invoice_partner', meta: { label: 'InvoicePartner' }, component: Views.MyInvoice.Base },
        { path: 'management/plan/:tag?', name: 'plan', meta: { label: 'Plans' }, component: Views.Plan.Base },
        { path: 'management/credit/:tag?', name: 'credit', meta: { label: 'Credit' }, component: Views.Credit.Base },
        { path: 'management/signout/:id?', name: 'signout', meta: { label: 'Signout' }, component: Views.Signout.Base },
      ]
    },
    {
      path: '/log', redirect: '/Log/main', name: 'Log', component: Container.Private,
      meta: { requiresAuth: true }, // require auth. (main.js - router filter)
      children: [
        // { path: 'main', name: 'Log_main', meta: { label: 'Log' }, component: Views.Integrity.Main },
        { path: 'login/:id?/:tag?', name: 'log_login', meta: { label: 'login' }, component: Views.Login.Base },
        { path: 'action/:id?/:tag?', name: 'log_action', meta: { label: 'action' }, component: Views.Action.Base },
        { path: 'system/:id?/:tag?', name: 'log_system', meta: { label: 'system' }, component: Views.System.Base },
        { path: 'install/:id?/:tag?', name: 'log_install', meta: { label: 'install' }, component: Views.Install.Base },
      ]
    },
    {
      path: '/board', redirect: '/board/main', name: 'Board', component: Container.Private,
      meta: { requiresAuth: true }, // require auth. (main.js - router filter)
      children: [
          { path: 'main/:id?/:tag?', name: 'board_main', meta: { label: 'Notice' }, component: Views.MainBoard.Base },
          { path: 'notice/:id?/:tag?', name: 'board_notice', meta: { label: 'Notice' }, component: Views.Notice.Base },
          { path: 'faq/:id?/:tag?', name: 'board_faq', meta: { label: 'FAQ' }, component: Views.FAQ.Base },
          { path: 'qna/:id?/:tag?', name: 'board_qna', meta: { label: 'Q & A' }, component: Views.QNA.Base },
      ]
    },
    {
      path: '/auth', name: 'auth_main', component: { render(c) { return c('router-view'); } },
      children: [
        { path: 'reset', name: 'auth_reset', component: Views.Auth.Reset, props: (route) => ({ token : route.query.token, username : route.query.username }) },
        { path: 'login', name: 'auth_login', component: Views.Auth.Login },
      ]
    },
    { path: '*', redirect: '/auth/login' }
  ]
});
